import type { ValuesType } from "utility-types"

export const COMPANY_DOMAIN = "farmhq.com"
export const CustomerService = {
  EMAIL_ADDRESS: `support@${COMPANY_DOMAIN}`,
  PHONE_NUMBER: "360-818-2632",
} as const

export const PRIVACY_POLICY_URL = `https://${COMPANY_DOMAIN}/privacy-policy`

export type AddDeviceErrorCode =
  | "ALREADY_ADDED"
  | "ALREADY_CLAIMED"
  | "EXPIRED"
  | "INVALID"

export const ADD_DEVICE_INPUT_MODE = {
  coda_device_alias: "coda_device_alias",
  device_share_code: "device_share_code",
} as const
export type AddDeviceInputMode = ValuesType<typeof ADD_DEVICE_INPUT_MODE>

export function getNodeEnv(): "development" | "production" {
  if (__DEV__) {
    return "development"
  }
  return "production"
}

export const PIVOT_DIRECTIONS = [
  "pivot_clockwise",
  "pivot_counterclockwise",
] as const
export type PivotDirection = (typeof PIVOT_DIRECTIONS)[number]

/**
 * Pivot check-ins older than this are treated as stale — state derived from
 * the last event is extrapolated rather than observed. Drives both the
 * detail card's "(stale)" badge and the map marker's ghosted arm.
 */
export const PIVOT_STALE_CHECK_IN_MS = 30 * 60 * 1000

/**
 * Installation types that represent center pivot irrigation systems.
 * Matches backend constants.CENTER_PIVOT_INSTALLATION_TYPES.
 *
 * The legacy "center_pivot" installation type was retired: migration 0264
 * flipped existing rows to "center_pivot_monitor" and migration 0265 dropped
 * the pivot_* columns on DeviceConfigurationV2. Geometry now lives on
 * CenterPivot.
 */
export const CENTER_PIVOT_INSTALLATION_TYPES = [
  "center_pivot_controller", // Controls pivot, refs CenterPivot
  "center_pivot_monitor",    // Monitors pivot, refs CenterPivot
] as const
export type CenterPivotInstallationType = (typeof CENTER_PIVOT_INSTALLATION_TYPES)[number]
